export default "__VITE_ASSET__CNoIeFCF__"